// extracted by mini-css-extract-plugin
export default {"button":"ClearButton__button--28ZjJ","hover":"ClearButton__hover--10Rl2"};